export const Cookie = {
  Keys: {
    TOKENS: "tokens",
  },
};
